<template>
    <div class="container" id="app">
        <router-view/>
    </div>
</template>
<script>
    export default {
        created() {
            const vm = this
            this.$nextTick(function () {
                const from = {params: {latest_list: 1, hot_list: 1}}
                const to = vm.$route
                vm.getList('latest_list', to, from);
                vm.getList('hot_list', to, from);
            })
        }
    }

</script>
<style>

</style>
